var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div'),(this.$route.name === 'Home')?_c('img',{staticClass:"archimede",attrs:{"src":require("../../assets/images/archimede.png"),"alt":"logo Archimede"}}):_vm._e(),_c('img',{attrs:{"src":require("../../assets/images/logo_dlp-white.svg"),"alt":"logo Disney"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }